import React, { ReactNode } from 'react';

import { Helmet } from 'react-helmet';

import { Logo } from 'shared/components/ihcl/icon';
import { WrappedLucideIcon } from 'shared/components/ihcl/lucideIcon';
import { styled } from 'shared/components/ihcl/styled';
import { isNative } from 'shared/helpers/native';
import withGoogleOptimize from 'shared/helpers/withGoogleOptimize';

type NonHiringContainerProps = {
  bodyClasses?: string;
  children: ReactNode;
};

const SignUpWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  maxHeight: '1000px',
  maxWidth: '768px',
  margin: '0 auto',
  paddingTop: '20px',
  paddingBottom: '40px',
  width: '100%',
  paddingLeft: '24px',
  paddingRight: '24px',
  textAlign: 'center',
});

const HeaderWrapper = styled('div', {
  textAlign: 'left',
});

const NonHiringContainer = ({
  bodyClasses = '',
  children,
}: NonHiringContainerProps) => (
  <div className="non-hiring">
    <Helmet>
      <body className={`${bodyClasses} registration-app`} />
    </Helmet>
    <SignUpWrapper>
      <HeaderWrapper>
        <div className="brand-logo mx-auto w-full px-[15px]">
          <Logo />
        </div>
        {isNative() && (
          <a href="/" className="back-btn">
            <WrappedLucideIcon name="ArrowLeft" aria-hidden="true" /> Back
          </a>
        )}
      </HeaderWrapper>
      {children}
    </SignUpWrapper>
  </div>
);

export default withGoogleOptimize(NonHiringContainer);
